import React from "react";
import { Parser } from 'components';
const Third = (props) => {
  const { langs, cancel, nextStep, order } = props;
  return (
    <div>
      <div className="font-size-16 pt-24px pt-32px  mb-48px ConfirmReturnPolicy max-height-380px h-100">
        <Parser html={order.shop_description?.return_policy ?? ''}/>
      </div>
      <div>
        <div className="mb-16px px-20px px-md-100px d-flex justify-content-center">
          <button className="return-item-btn-actions font-size-16 w-100 font-medium font-weight-normal py-16px btn bg-middle-gray text-dark d-block mr-12px"
            type="button" onClick={nextStep}>
            {langs.Continue}
          </button>
          <button className="return-item-btn-actions font-size-16 w-100 font-medium font-weight-normal py-16px btn bg-middle-gray text-dark d-block "
            type="button" onClick={cancel}>
            {langs.NM_Quit}
          </button>
        </div>
      </div>
    </div>
  )
}
export default Third